import { Component, Input, OnInit } from '@angular/core';
import { SasisopaService } from '../../../../../services/sasisopa.service';
import { NbDialogRef } from '@nebular/theme';
import Swal, { SweetAlertIcon } from 'sweetalert2';

type AuditProgram = {
  station_id: string;
  instalation: string;
  objective: string;
  scope: string;
  procedure: string;
  frequency: string;
  responsabilities: string;
  requirements: string;
  audit: string;
  date_init: string;
  date_end: string;
}

@Component({
  selector: 'ngx-audit-program-form',
  templateUrl: './audit-program-form.component.html',
  styleUrls: ['./audit-program-form.component.scss']
})
export class AuditProgramFormComponent implements OnInit {
  @Input() stationId: string;
  @Input() action: string;
  @Input() infoEdit: AuditProgram & { id: string };
  loading = false;
  data: AuditProgram = {
    station_id: '',
    instalation: '',
    objective: '',
    scope: '',
    procedure: '',
    frequency: '',
    responsabilities: '',
    requirements: '',
    audit: 'Interna',
    date_init: '',
    date_end: ''
  };

  constructor(
    private sasisopaService: SasisopaService,
    protected ref: NbDialogRef<AuditProgramFormComponent>,
  ) { }

  async ngOnInit() {
    this.loading = true;
    await this.checkIfCreateOrEdit();
    this.loading = false;
  }

  async store() {
    this.data.station_id = this.stationId;
    this.loading = true;
    const [error] = await this.sasisopaService.createAuditProgram(this.data);
    if (error) {
      this.loading = false;
      return this.alert('Error', 'error', 'Oops... ocurrio algo, intenta mas tarde');
    }
    this.loading = false;
    await this.alert('Registro creado con éxito', 'success');
    this.ref.close(true);
  }

  async edit() {
    this.loading = true;
    this.data.station_id = this.stationId;
    const [error] = await this.sasisopaService.editAuditProgram(this.infoEdit.id, this.data);
    if (error) {
      this.loading = false;
      return this.alert('Error', 'error', 'Oops... ocurrio algo, intenta mas tarde');
    }
    this.loading = false;
    await this.alert('Registro editado con éxito', 'success');
    this.ref.close(true);
  }

  handleSubmit() {
    if (this.action === 'edit') {
      this.edit();
    } else {
      this.store();
    }
  }

  alert(title: string = '', type: SweetAlertIcon = 'success', text: string = '') {
    return Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

  async checkIfCreateOrEdit() {
    if (this.action === 'edit') this.data = this.infoEdit
  }
}
